"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const tz_offset_1 = require("tz-offset");
const MailOutline_1 = __importDefault(require("@material-ui/icons/MailOutline"));
const SmsOutlined_1 = __importDefault(require("@material-ui/icons/SmsOutlined"));
const PhoneOutlined_1 = __importDefault(require("@material-ui/icons/PhoneOutlined"));
const UnfoldMore_1 = __importDefault(require("@material-ui/icons/UnfoldMore"));
const UnfoldLess_1 = __importDefault(require("@material-ui/icons/UnfoldLess"));
const AttachFileOutlined_1 = __importDefault(require("@material-ui/icons/AttachFileOutlined"));
const LanguageOutlined_1 = __importDefault(require("@material-ui/icons/LanguageOutlined"));
const CropOriginalOutlined_1 = __importDefault(require("@material-ui/icons/CropOriginalOutlined"));
const CloseOutlined_1 = __importDefault(require("@material-ui/icons/CloseOutlined"));
const GetAppOutlined_1 = __importDefault(require("@material-ui/icons/GetAppOutlined"));
const core_1 = require("@material-ui/core");
const OpendoorLogoSvg_1 = __importDefault(require("../OpendoorLogoSvg/OpendoorLogoSvg"));
const UserAvatar_1 = __importDefault(require("../UserAvatar/UserAvatar"));
const silica_1 = require("@opendoor/silica");
const Carousel_1 = __importDefault(require("../Carousel/Carousel"));
const lineHeight = 21;
const iconStyles = {
    color: silica_1.colors.gray4,
    stroke: 'none',
    height: '20px',
    width: '20px',
};
/**
 * Used to get the right icon for the event type.
 * @param type the type of a event.
 * @param isReply if the email communication event is a reply to a email thread.
 */
function getEventTypeIcon(type, isReply) {
    switch (type) {
        case 'Email':
            if (isReply) {
                return (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: iconStyles },
                    react_1.default.createElement("path", { d: "M15 3.5C15 2.675 14.325 2 13.5 2H1.5C0.675 2 0 2.675 0 3.5V12.5C0 13.325 0.675 14 1.5 14H13.5C14.325 14 15 13.325 15 12.5V3.5ZM13.5 3.5L7.5 7.25L1.5 3.5H13.5ZM13.5 12.5H1.5V5L7.5 8.75L13.5 5V12.5Z", fill: silica_1.colors.gray4 }),
                    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 15.5C4 16.325 4.675 17 5.5 17H16.5C17.325 17 18 16.325 18 15.5V7.5C18 6.675 17.325 6 16.5 6V6.5V15.5H4.5H4Z", fill: silica_1.colors.gray4 })));
            }
            else {
                return react_1.default.createElement(MailOutline_1.default, { style: iconStyles });
            }
        case 'Sms':
            return react_1.default.createElement(SmsOutlined_1.default, { style: iconStyles });
        case 'Voicemail':
        case 'Phone':
            return react_1.default.createElement(PhoneOutlined_1.default, { style: iconStyles });
        case 'Notes':
            return (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: iconStyles },
                react_1.default.createElement("path", { d: "M16.92 10.1944L16.0575 9.33187C15.615 8.88938 14.9025 8.88938 14.4675 9.33187L10.5 13.2994V15.7519H12.9525L16.92 11.7844C17.3625 11.3419 17.3625 10.6294 16.92 10.1944ZM12.435 14.5894H11.6625V13.8169L14.25 11.2294L15.0225 12.0019L12.435 14.5894Z", fill: silica_1.colors.gray4 }),
                react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 9.67745V3.75H3V14.25H9V15.75H3C2.175 15.75 1.5 15.075 1.5 14.25V3.75C1.5 2.925 2.175 2.25 3 2.25H12C12.825 2.25 13.5 2.925 13.5 3.75V8.17758L12 9.67745Z", fill: silica_1.colors.gray4 })));
        default:
            return react_1.default.createElement(SmsOutlined_1.default, { style: iconStyles });
    }
}
function getAttachmentIcon(mimeType) {
    if (mimeType.startsWith('image/')) {
        return react_1.default.createElement(CropOriginalOutlined_1.default, { className: "gray4", fontSize: "small", style: iconStyles });
    }
    return react_1.default.createElement(AttachFileOutlined_1.default, { className: "gray4", fontSize: "small", style: iconStyles });
}
function getAttachmentsIcon(attachments) {
    if (!attachments || attachments.length === 0) {
        return;
    }
    if (attachments.every((attachment) => attachment.mimeType.startsWith('image/'))) {
        return react_1.default.createElement(CropOriginalOutlined_1.default, { className: "gray4", fontSize: "small", style: iconStyles });
    }
    return react_1.default.createElement(AttachFileOutlined_1.default, { className: "gray4", fontSize: "small", style: iconStyles });
}
/**
 * Used to render one single event on the timeline. It supports all event types.
 */
const EventContent = ({ from, to, isReply, fromOD, type, title, message, timestamp, attachments, hoverActions, expandedAll, }) => {
    const [hovered, setHovered] = react_1.useState(false);
    const [expanded, setExpanded] = react_1.useState(expandedAll);
    const icon = getEventTypeIcon(type, isReply);
    react_1.useEffect(() => {
        setExpanded(expandedAll);
    }, [expandedAll]);
    const [openDialog, setOpenDialog] = react_1.useState(false);
    const [curPhotoAttachmentIndex, setCurPhotoAttachmentIndex] = react_1.useState(0);
    const photoAttachments = (attachments === null || attachments === void 0 ? void 0 : attachments.filter((attachment) => attachment.mimeType.startsWith('image/'))) || [];
    const otherAttachments = (attachments === null || attachments === void 0 ? void 0 : attachments.filter((attachment) => !attachment.mimeType.startsWith('image/'))) || [];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `w-100% flex justify-center items-center ${hovered ? 'cursor-pointer' : ''}`, style: hovered
                ? {
                    width: `calc(100% + 28px)`,
                    boxShadow: '0px 7px 14px rgba(29, 44, 76, 0.15)',
                    borderRadius: '4px',
                }
                : {} },
            react_1.default.createElement("div", { className: `fs-7 w-100% flex justify-start items-start bo-gray2 bob-1 pv-5 pr-5`, style: { width: `${hovered ? 'calc(100% - 28px)' : '100%'}` }, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), onClick: () => setExpanded(!expanded) },
                react_1.default.createElement("div", { className: "flex items-center", style: { width: '5%' } },
                    react_1.default.createElement("div", { style: { height: `${lineHeight * 2}px` }, className: "relative flex items-center" },
                        react_1.default.createElement(UserAvatar_1.default, { url: from.avatarUrl, name: from.name, size: 32, rounded: true }),
                        fromOD && (react_1.default.createElement("div", { className: "absolute flex justify-center items-center bg-blue1 bo-radius-circle", style: { width: '16px', height: '16px', bottom: 0, right: '-2px' } },
                            react_1.default.createElement(OpendoorLogoSvg_1.default, { style: { width: '12px' }, color: "blue4" }))))),
                react_1.default.createElement("div", { className: "flex items-center pr-6", style: { width: '15%', minHeight: `${lineHeight * 2}px` } },
                    react_1.default.createElement("div", { className: "flex flex-column justify-center items-start w-100%" },
                        react_1.default.createElement("div", { className: "b gray6 w-100% overflow-hidden truncate-ellipsis", style: expanded ? { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } : {} }, from.name),
                        to.length > 0 && (react_1.default.createElement("div", { className: "fs-8 gray4 w-100% overflow-hidden truncate-ellipsis", style: expanded ? { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } : {} },
                            "to ",
                            to[0].name,
                            to.length > 1 ? ` +${to.length - 1}` : '')))),
                react_1.default.createElement("div", { className: "flex items-center", style: { width: '5%', height: `${lineHeight * 2}px` } }, icon),
                react_1.default.createElement("div", { className: "flex items-center", style: { width: '60%', minHeight: `${lineHeight * 2}px` } },
                    react_1.default.createElement("div", { className: "flex flex-column justify-center items-start flex-wrap w-100%" },
                        react_1.default.createElement("div", { className: "gray6 overflow-hidden truncate-ellipsis w-100%", style: expanded ? { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } : {} }, title),
                        react_1.default.createElement("div", { className: "gray4 overflow-hidden w-100%", style: expanded
                                ? { whiteSpace: 'pre-wrap', wordBreak: 'break-word' }
                                : {
                                    WebkitLineClamp: title ? 1 : 2,
                                    WebkitBoxOrient: 'vertical',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                } }, message),
                        expanded && attachments && attachments.length > 0 && (react_1.default.createElement("div", { className: "flex flex-wrap w-100% mt-4" },
                            photoAttachments.map((attachment, index) => (react_1.default.createElement(core_1.Chip, { className: "bo-gray4 mr-4 mb-4", key: index, label: react_1.default.createElement("div", { className: "flex items-center" },
                                    getAttachmentIcon(attachment.mimeType),
                                    react_1.default.createElement("span", { className: "gray4" }, attachment.filename)), onClick: (e) => {
                                    e.stopPropagation();
                                    setCurPhotoAttachmentIndex(index);
                                    setOpenDialog(true);
                                }, clickable: true, variant: "outlined" }))),
                            otherAttachments.map((attachment, index) => (react_1.default.createElement(core_1.Chip, { className: "bo-gray4 mr-4 mb-4", key: index, label: react_1.default.createElement("div", { className: "flex items-center" },
                                    getAttachmentIcon(attachment.mimeType),
                                    react_1.default.createElement("span", { className: "gray4" }, attachment.filename)), onClick: (e) => {
                                    e.stopPropagation();
                                    window.open(attachment.url, '_target');
                                }, clickable: true, variant: "outlined" }))))))),
                react_1.default.createElement("div", { className: "flex justify-end items-center", style: { width: '5%', height: `${lineHeight * 2}px` } }, getAttachmentsIcon(attachments)),
                react_1.default.createElement("div", { style: { width: '10%', height: `${lineHeight * 2}px` }, className: "tr flex justify-end items-center" }, hovered ? (hoverActions.map((action, index) => (react_1.default.createElement("div", { className: "pl-4 h-100% flex items-center", key: index }, action)))) : (react_1.default.createElement("span", null, timestamp.diff(moment_1.default(), 'hour') > -24
                    ? timestamp.format('h:mm A')
                    : timestamp.format('MMM D')))))),
        photoAttachments.length > 0 && (react_1.default.createElement(core_1.Dialog, { fullScreen: true, open: openDialog, fullWidth: true, maxWidth: "lg", onClose: () => setOpenDialog(false) },
            react_1.default.createElement("div", { className: "flex flex-column h-100% ph-7 pv-4" },
                react_1.default.createElement("div", { className: "flex justify-between items-center" },
                    react_1.default.createElement(core_1.IconButton, { onClick: () => setOpenDialog(false) },
                        react_1.default.createElement(CloseOutlined_1.default, { style: iconStyles })),
                    react_1.default.createElement(core_1.IconButton, { onClick: () => window.open(photoAttachments[curPhotoAttachmentIndex].url, '_target') },
                        react_1.default.createElement(GetAppOutlined_1.default, { style: iconStyles }))),
                react_1.default.createElement(Carousel_1.default, { className: "flex-grow-1 w-100% h-100%", onIndexChange: setCurPhotoAttachmentIndex, startIndex: curPhotoAttachmentIndex }, photoAttachments.map((attachment, index) => (react_1.default.createElement("img", { key: index, src: attachment.url, alt: attachment.filename })))))))));
};
/**
 * Used to get the correct props to pass into EventContent then use it to render a email communication event.
 */
const EmailEventContent = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(EventContent, Object.assign({}, props, { to: [...props.to, ...props.ccs, ...props.bccs], fromOD: props.outgoing })));
};
/**
 * Used to get the correct props to pass into EventContent then use it to render a SMS communication event.
 */
const SmsEventContent = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(EventContent, Object.assign({}, props, { to: props.to, attachments: props.photos, fromOD: props.outgoing })));
};
/**
 * Used to get the correct props to pass into EventContent then use it to render a voicemail communication event.
 */
const VoiceMailEventContent = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(EventContent, Object.assign({}, props, { to: [], fromOD: props.outgoing, message: props.to.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            "Left a voicemail to ",
            react_1.default.createElement("span", { className: "b" }, props.to[0].name))) })));
};
/**
 * Used to get the correct props to pass into EventContent then use it to render a phone call communication event.
 */
const PhoneEventContent = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(EventContent, Object.assign({}, props, { to: [], fromOD: props.outgoing, message: props.to.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            "Called ",
            react_1.default.createElement("span", { className: "b" }, props.to[0].name))) })));
};
/**
 * Used to get the correct props to pass into EventContent then use it to render a note event.
 */
const NotesEventContent = (_a) => {
    var props = __rest(_a, []);
    return react_1.default.createElement(EventContent, Object.assign({}, props, { to: [], message: props.note, fromOD: true }));
};
/**
 * Helper function to get involved parties for any type of a event.
 * @param event a event on the timeline.
 */
function getInvolvedParties(event) {
    const parties = [];
    if (event.type === 'Notes') {
        parties.push(event.from.party);
    }
    if (event.type === 'Phone') {
        const phoneEvent = event;
        parties.push(phoneEvent.from.party, ...phoneEvent.to.map((user) => user.party));
    }
    if (event.type === 'Sms') {
        const smsEvent = event;
        parties.push(smsEvent.from.party, ...smsEvent.to.map((user) => user.party));
    }
    if (event.type === 'Voicemail') {
        const voicemailEvent = event;
        parties.push(voicemailEvent.from.party, ...voicemailEvent.to.map((user) => user.party));
    }
    if (event.type === 'Email') {
        const emailEvent = event;
        parties.push(emailEvent.from.party, ...emailEvent.to.map((user) => user.party), ...emailEvent.ccs.map((user) => user.party), ...emailEvent.bccs.map((user) => user.party));
    }
    return parties.filter((p) => p);
}
/**
 * Helper function to filter a list of events based on filters value.
 * @param events list of events to filter.
 * @param onlyShowComms if only show comms filter is turned on.
 * @param eventType event type specified.
 * @param party party specified.
 */
function filterEvents(events, onlyShowComms, eventTypes, party) {
    return events.filter((event) => {
        if (onlyShowComms && event.type === 'Notes') {
            return false;
        }
        if (eventTypes.length > 0 && !eventTypes.includes(event.type)) {
            return false;
        }
        if (party) {
            const partiesInvolved = getInvolvedParties(event);
            return partiesInvolved.includes(party);
        }
        return true;
    });
}
/**
 * Used to render a timeline UI for events, communications and activity logs, with filters.
 *
 * Figma design: https://www.figma.com/file/P14z33bW0Ky3J3GCxgNJcJ/Pact-2021?node-id=587%3A1377
 *
 * Content for each item:
 *
 * 1. User avatar, is the communication is outgoing, mark it with OD logo.
 * 2. User name (from, to and +x).
 * 3. Event type indicated with icons.
 * 4. Message with optional title.
 * 5. Timestamp.
 *
 * Hover effect:
 *
 * 1. Show box shadow.
 * 2. Render hoverActions defined in the props.
 *
 * Click actions:
 *
 * 1. Expand long message.
 *
 * Filters:
 *
 * 1. Filter by event type.
 * 2. Filter by party involved.
 * 3. Filter for only show comms.
 *
 * Other functionalities:
 *
 * 1. Expand all messages.
 * 2. Show timestamp based on local timezone.
 */
const Timeline = ({ events, showFilters, timezone }) => {
    const [eventTypes, setEventTypes] = react_1.useState([]);
    const [party, setParty] = react_1.useState();
    const [onlyShowComms, setOnlyShowComms] = react_1.useState(false);
    const [expandedAll, setExpandedAll] = react_1.useState(false);
    const [useLocalTime, setUseLocalTime] = react_1.useState(false);
    const filteredEvents = filterEvents(events, onlyShowComms, eventTypes, party);
    const eventTypesFilterOptions = ['Email', 'Notes', 'Phone', 'Sms', 'Voicemail'];
    const partyFilterOptions = ['Seller', 'Buyer', 'Other'];
    return (react_1.default.createElement("div", { style: { lineHeight: `${lineHeight}px` } },
        showFilters && (react_1.default.createElement("div", { className: "flex justify-between items-center w-100% mb-6 pr-5" },
            react_1.default.createElement("div", { className: "w-40% flex justify-start items-center" },
                react_1.default.createElement(core_1.FormControl, { className: "mr-6", style: { width: '45%' }, variant: "outlined" },
                    react_1.default.createElement(core_1.InputLabel, { id: "event-type-filter-label" }, "Event type"),
                    react_1.default.createElement(core_1.Select, { labelId: "event-type-filter-label", id: "event-type-filter", value: eventTypes, onChange: (event) => setEventTypes(event.target.value), renderValue: (selected) => selected.join(', '), multiple: true }, eventTypesFilterOptions.map((type) => (react_1.default.createElement(core_1.MenuItem, { key: type, value: type },
                        react_1.default.createElement(core_1.Checkbox, { checked: eventTypes.indexOf(type) > -1 }),
                        type))))),
                react_1.default.createElement(core_1.FormControl, { style: { width: '45%' }, variant: "outlined" },
                    react_1.default.createElement(core_1.InputLabel, { id: "party-filter-label" }, "Party involved"),
                    react_1.default.createElement(core_1.Select, { labelId: "party-filter-label", id: "party-filter", value: party, onChange: (event) => setParty(event.target.value) },
                        react_1.default.createElement(core_1.MenuItem, { value: undefined },
                            react_1.default.createElement("em", null, "All")),
                        partyFilterOptions.map((party) => (react_1.default.createElement(core_1.MenuItem, { key: party, value: party }, party)))))),
            react_1.default.createElement("div", { className: "40% flex justify-end items-center" },
                react_1.default.createElement(core_1.FormControlLabel, { value: "start", control: react_1.default.createElement(core_1.Switch, { color: "primary", value: onlyShowComms, onChange: (event) => setOnlyShowComms(event.target.checked) }), label: "Only show comms", labelPlacement: "start" }),
                react_1.default.createElement(core_1.IconButton, { className: "ml-5 boa-1 bo-gray2", onClick: () => setExpandedAll(!expandedAll) }, expandedAll ? (react_1.default.createElement(core_1.Tooltip, { title: "Collapse all" },
                    react_1.default.createElement(UnfoldLess_1.default, { style: iconStyles }))) : (react_1.default.createElement(core_1.Tooltip, { title: "Expand all" },
                    react_1.default.createElement(UnfoldMore_1.default, { style: iconStyles })))),
                timezone && (react_1.default.createElement(core_1.IconButton, { className: "ml-5 boa-1 bo-gray2", onClick: () => {
                        setUseLocalTime(!useLocalTime);
                    } }, useLocalTime ? (react_1.default.createElement(core_1.Tooltip, { title: "Currently based on local time" },
                    react_1.default.createElement(LanguageOutlined_1.default, { style: iconStyles }))) : (react_1.default.createElement(core_1.Tooltip, { title: "Currently based on my timezone" },
                    react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: iconStyles, className: "cursor-pointer" },
                        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.9925 1.5C4.8525 1.5 1.5 4.86 1.5 9C1.5 13.14 4.8525 16.5 8.9925 16.5C9.19887 16.5 9.40328 16.4917 9.60543 16.4754C8.57866 15.6078 7.91543 14.3234 7.87679 12.8833C7.76119 12.5951 7.65789 12.3005 7.56754 12H7.93234C8.01471 11.4665 8.18358 10.9616 8.42416 10.5H7.245C7.1775 10.005 7.125 9.51 7.125 9C7.125 8.49 7.1775 7.9875 7.245 7.5H10.755C10.7897 7.75054 10.8204 8.00504 10.8421 8.26249C11.3009 8.06717 11.7958 7.94015 12.3141 7.89423C12.3008 7.76263 12.286 7.63132 12.27 7.5H14.805C14.8787 7.79468 14.9354 8.09784 14.9682 8.40775C15.5475 8.70426 16.0596 9.11329 16.4758 9.60599C16.4918 9.40609 16.5 9.20399 16.5 9C16.5 4.86 13.14 1.5 8.9925 1.5ZM14.19 6.00001H11.9775C11.7375 5.06251 11.3925 4.16251 10.9425 3.33001C12.3225 3.80251 13.47 4.76251 14.19 6.00001ZM10.4325 5.99999C10.11 4.92749 9.62254 3.92999 9.00004 3.02999C8.37754 3.92999 7.89004 4.92749 7.56754 5.99999H10.4325ZM3.195 10.5C3.075 10.02 3 9.5175 3 9C3 8.4825 3.075 7.98 3.195 7.5H5.73C5.67 7.995 5.625 8.49 5.625 9C5.625 9.51 5.67 10.005 5.73 10.5H3.195ZM6.02248 12H3.80998C4.52998 13.245 5.67748 14.1975 7.05748 14.67C6.60748 13.8375 6.26248 12.9375 6.02248 12ZM6.02248 6.00001H3.80998C4.52998 4.75501 5.67748 3.80251 7.05748 3.33001C6.60748 4.16251 6.26248 5.06251 6.02248 6.00001Z", fill: silica_1.colors.gray4 }),
                        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3393 9.8625V9.21429C13.3393 8.88883 13.0755 8.625 12.75 8.625C12.4246 8.625 12.1607 8.88883 12.1607 9.21429V9.86252C11.0063 10.0969 10.097 11.0062 9.8626 12.1607H9.21429C8.88883 12.1607 8.625 12.4245 8.625 12.75C8.625 13.0754 8.88883 13.3393 9.21429 13.3393H9.86259C10.0969 14.4938 11.0063 15.4031 12.1608 15.6375V16.2857C12.1608 16.6112 12.4246 16.875 12.7501 16.875C13.0755 16.875 13.3394 16.6112 13.3394 16.2857V15.6375C14.4938 15.4031 15.4032 14.4938 15.6376 13.3393H16.2858C16.6113 13.3393 16.8751 13.0755 16.8751 12.75C16.8751 12.4246 16.6113 12.1607 16.2858 12.1607H15.6376C15.4032 11.0062 14.4938 10.0968 13.3393 9.8625ZM12.7568 14.5178C13.7301 14.5142 14.5179 13.7241 14.5179 12.75C14.5179 11.7749 13.7285 10.9842 12.7539 10.9821H12.7463C11.7717 10.9842 10.9822 11.7749 10.9822 12.75C10.9822 13.7241 11.7701 14.5142 12.7434 14.5178H12.7568ZM12.75 13.3393C13.0755 13.3393 13.3393 13.0755 13.3393 12.75C13.3393 12.4246 13.0755 12.1607 12.75 12.1607C12.4246 12.1607 12.1607 12.4246 12.1607 12.75C12.1607 13.0755 12.4246 13.3393 12.75 13.3393Z", fill: silica_1.colors.gray4 }))))))))),
        react_1.default.createElement("div", { className: "w-100% bo-gray2 bot-1 flex flex-column items-center" }, filteredEvents.map((event, index) => {
            switch (event.type) {
                case 'Email':
                    return (react_1.default.createElement(EmailEventContent, Object.assign({ key: index, expandedAll: expandedAll }, event, { timestamp: timezone && useLocalTime
                            ? moment_1.default(event.timestamp).utcOffset(-tz_offset_1.offsetOf(timezone))
                            : event.timestamp })));
                case 'Sms':
                    return (react_1.default.createElement(SmsEventContent, Object.assign({ key: index, expandedAll: expandedAll }, event, { timestamp: timezone && useLocalTime
                            ? moment_1.default(event.timestamp).utcOffset(-tz_offset_1.offsetOf(timezone))
                            : event.timestamp })));
                case 'Voicemail':
                    return (react_1.default.createElement(VoiceMailEventContent, Object.assign({ key: index, expandedAll: expandedAll }, event, { timestamp: timezone && useLocalTime
                            ? moment_1.default(event.timestamp).utcOffset(-tz_offset_1.offsetOf(timezone))
                            : event.timestamp })));
                case 'Phone':
                    return (react_1.default.createElement(PhoneEventContent, Object.assign({ key: index, expandedAll: expandedAll }, event, { timestamp: timezone && useLocalTime
                            ? moment_1.default(event.timestamp).utcOffset(-tz_offset_1.offsetOf(timezone))
                            : event.timestamp })));
                case 'Notes':
                    return (react_1.default.createElement(NotesEventContent, Object.assign({ key: index, expandedAll: expandedAll }, event, { timestamp: timezone && useLocalTime
                            ? moment_1.default(event.timestamp).utcOffset(-tz_offset_1.offsetOf(timezone))
                            : event.timestamp })));
            }
        }))));
};
exports.default = Timeline;
